import NavMegaMenu, { MenuColumn, MenuItem, MenuFooter, MenuFooterLink } from '@/components/layout/NavMegaMenu';

type AboutNavDropdownProps = {
  active: boolean
}

// Content for the "About us" nav menu: the company and people, the channels to
// follow along, and the ways to get in touch — with low-traffic legal pages
// dropped to a quiet strip at the bottom. The interaction mechanics live in
// NavMegaMenu.
export default function AboutNavDropdown({ active }: AboutNavDropdownProps) {
  return (
    <NavMegaMenu
      label="About us"
      href="/docs/about/"
      active={active}
      footer={
        <MenuFooter label="Legal">
          <MenuFooterLink href="/docs/terms/">Terms &amp; conditions</MenuFooterLink>
          <MenuFooterLink href="/docs/privacy/">Privacy Policy</MenuFooterLink>
          <MenuFooterLink href="/impressum/">Impressum</MenuFooterLink>
        </MenuFooter>
      }
    >
      <MenuColumn heading="The organisation">
        <MenuItem href="/docs/about/" title="About OpenSanctions" desc="What we do & why we're open" />
        <MenuItem href="/docs/company/team/" title="The team" desc="The people behind the site" />
        <MenuItem href="/docs/company/jobs/" title="Work with us" desc="Open roles in Berlin & remote" />
      </MenuColumn>
      <MenuColumn heading="Follow along">
        <MenuItem href="/articles/" title="Blog" desc="Analysis and news" />
        <MenuItem href="/newsletter/" title="Newsletter" desc="Product updates in your inbox" />
        <MenuItem href="https://discuss.opensanctions.org" title="Forum" desc="Ask questions and get help" />
      </MenuColumn>
      <MenuColumn heading="Get in touch">
        <MenuItem href="/contact/" title="Contact us" desc="General enquiries" />
        <MenuItem href="/sales/" title="Talk to sales" desc="Licensing & commercial use" />
        <MenuItem href="/support/" title="Get support" desc="Help with data & the API" />
      </MenuColumn>
    </NavMegaMenu>
  );
}
